/**
 * Zeigt Element (analog zu jQuery .show())
 */
export function show(el: HTMLElement, display = ''): void {
  el.style.display = display;
}

/**
 * Versteckt Element (analog zu jQuery .hide())
 */
export function hide(el: HTMLElement): void {
  el.style.display = 'none';
}